module.exports = __webpack_public_path__ + "img/PubBG_Dark.e5139f4a.svg";